import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { useAppSelector } from '../../../../hooks';
import { getSubjectColorNew } from '../../../../helper';
import { ellipsisTwoLineTypoStyles } from '..';

import {
  IGroupedSubTopic,
  IGroupedTopic,
} from '../../../../store/SubTopicSlice';
import { getTopicState } from '../../../../store/TopicSlice';

import CircularProgressWithValue from './CircularProgressWithValue';
import { TP_COLORS } from '../../../../constants';
import { getSubTopicUrl } from '../../Resources';

interface AssessmentItemProps {
  subTopic: IGroupedSubTopic;
  topicData: IGroupedTopic;
  assessmentProgress: boolean;
}

const AssessmentListItem: React.FC<AssessmentItemProps> = ({
  subTopic,
  topicData,
  assessmentProgress,
}) => {
  // Store
  const { topicsWithSubTopics } = useAppSelector(getTopicState);

  const subjectColor = getSubjectColorNew(topicData.subject || '');

  const getAssessmentDescription = (subTopicName: string) => {
    if (topicsWithSubTopics.length) {
      const filteredTopics = topicsWithSubTopics.filter(
        (item) => !item.isAssessment && item.name !== 'Overview'
      );
      return `The ${subTopicName} quiz covers fundamental concepts such as ${filteredTopics
        .map((topic) => topic.name)
        .join(', ')}.`;
    }

    return '';
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
      }}
    >
      <Grid item xs={12} sm={9} md={10} lg={10}>
        <Box display="flex" alignItems="center">
          <CircularProgressWithValue
            value={assessmentProgress ? 100 : 0}
            progressProps={{ marginRight: '5px' }}
            color={subjectColor}
          />
          <Box marginLeft="20px">
            <Typography
              component="h3"
              variant="h6"
              fontSize="18px"
              color={TP_COLORS.gray.dark}
            >
              {subTopic.name}
            </Typography>
            <Typography
              component="p"
              variant="subtitle2"
              sx={ellipsisTwoLineTypoStyles}
            >
              {getAssessmentDescription(subTopic.name)}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        sm={3}
        md={2}
        lg={2}
        sx={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <Button
          variant="outlined"
          component={Link}
          to={`${getSubTopicUrl(subTopic, topicData)}/quiz`}
          sx={{
            color: subjectColor,
            borderColor: subjectColor,
            '&:hover': {
              borderColor: subjectColor,
            },
            marginLeft: '16px',
            minWidth: '120px',
          }}
        >
          {assessmentProgress ? 'Reattempt Quiz' : 'Attempt Quiz'}
        </Button>
      </Grid>
    </Grid>
  );
};

export default AssessmentListItem;
